import React from 'react';
import { BellIcon } from 'lucide-react';
import type { CitizenScreen } from '../../types/navigation';
import type { CitizenSession } from './CitizenApp';
import { useStore } from '../../contexts/StoreContext';
import { MobileHeader } from '../../components/mobile/MobileHeader';
import { buildNotifications } from '../../utils/notifications';
import { fmtDateTime } from '../../utils/bn';
const DOT = {
  navy: 'bg-navy',
  green: 'bg-success',
  danger: 'bg-danger',
  warning: 'bg-warning'
};
export function Notifications({
  session,
  go
}: {
  session: CitizenSession;
  go: (s: CitizenScreen) => void;
}) {
  const {
    cases
  } = useStore();
  const mine = cases.filter(c => session.guestPcr ? c.pcr === session.guestPcr : c.mobile === session.mobile);
  const notes = buildNotifications(mine);
  return <>
      <MobileHeader appName="ডিএমপি যানবাহন সেবা" title="বিজ্ঞপ্তি" onBack={() => go({
      name: 'home'
    })} data-id="element-1684" data-mp="161q4n603o35g" />
      <div className="flex-1 overflow-y-auto no-scrollbar px-4 py-4" data-id="element-1685" data-mp="1ayyodb0wcf8t">
        {notes.length === 0 && <div className="flex flex-col items-center py-16 text-ink-muted" data-id="element-1686" data-mp="3vcndcoinv8qm"><BellIcon className="h-8 w-8" data-id="element-1687" data-mp="3qelt409i13dk" /><p className="mt-2 text-sm" data-id="element-1688" data-mp="3qedeo3xq9q09">কোনো বিজ্ঞপ্তি নেই।</p></div>}
        <ul className="card divide-y divide-line" data-id="element-1689" data-mp="3md08ttumxmtc">
          {notes.map((n, i) => <li key={i} data-id="element-1690" data-mp="3meuwvh17dv1n" data-mpi={i}>
              <button onClick={() => go(n.title.includes('অবমুক্তি পত্র') ? {
            name: 'letter',
            pcr: n.pcr
          } : {
            name: 'case',
            pcr: n.pcr
          })} className="flex w-full gap-3 px-4 py-3 text-left hover:bg-navy-50" data-id="element-1691" data-mp="3hegn9ujyed1i">
                <span className={`mt-1.5 h-2.5 w-2.5 shrink-0 rounded-full ${DOT[n.tone]}`} data-id="element-1692" data-mp="37nvrsfzktomt" />
                <span className="min-w-0" data-id="element-1693" data-mp="32oj7a1w6gtne">
                  <span className="block text-sm font-semibold text-ink" data-id="element-1694" data-mp="32paqed8l8yws">{n.title}</span>
                  <span className="block text-xs text-ink-muted" data-id="element-1695" data-mp="2yp0ll3wj8eji">{n.pcr} · {n.body}</span>
                  <span className="block text-[11px] text-ink-soft" data-id="element-1696" data-mp="2tn1h1qp23bkz">{fmtDateTime(n.at)}</span>
                </span>
              </button>
            </li>)}
        </ul>
      </div>
    </>;
}